module.exports = __webpack_public_path__ + "static/1-7ce59085cd348a249e1e146813108537.jpg";